import { useEffect, useState } from "react";
import makeAnimated from 'react-select/animated';
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { FaPlus } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import NoData from "../../NoData";
import Loading from "../../Loading";

export default function Package() {

  const [subscriptions, setSubscriptions] = useState({
    name: "",
    amount: "",
    total_request: "",
    grade: "",
    description: [],
    status: 1,
    type: 1,
    id: ""
  });

  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [show, setShow] = useState(false);
  const adminToken = localStorage.getItem("authAdminToken");
  const handleClose = () => setShow(false);
  const [loading, setLoading] = useState(true);


  // Show Details Section
  const fetchAllSubscription = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getAllSubscriptionPackage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${adminToken}`
      },
    });
    return response.json();
  };

  // Edit Section
  const handleEdit = async (event) => {
    event.preventDefault();

    if (!subscriptions.name) {
      toast.info("Name field is required.");
      return;
    }
    if (!subscriptions.amount) {
      toast.info("Amount field is required.");
      return;
    }
    if (!subscriptions.total_request) {
      toast.info("Total request field is required.");
      return;
    }
    if (!subscriptions.grade) {
      toast.info("Grade field is required.");
      return;
    }

    const postData = structuredClone(subscriptions);
    // postData.grade = JSON.stringify(postData.grade);
    postData.description = postData.description.filter((elem) => elem != "");
    postData.description = JSON.stringify(postData.description);


    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/setSubscriptionPackage`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${adminToken}`
        },
        body: JSON.stringify(postData),
      });
      const data = await response.json();

      if (data.status === true) {
        toast.success("Subscription Package update successfully!");
        setShowForm(false);
      } else {
        toast.error("Failed to update Subscription Package.");
      }

    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
    }
  };

  // Delete Section
  const handleDelete = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/deleteSubscriptionPackage`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${adminToken}`
        },
        body: JSON.stringify({ id: subscriptions.id }),
      });
      const data = await response.json();

      if (data.status === true) {
        fetchAllSubscription().then((res) => {
          if (res.status) {
            setSubscriptionDetails(res?.subscriptions);
          } else {
            toast.error("Failed to load subscriptions. Please try again.");
          }
        }).catch((error) => {
          toast.error("Unable to fetch subscriptions at the moment.");
        });


        toast.success("Subscription package delete successfully!");
        setShow(false);
      } else {
        toast.error("Failed to delete subscription package.");
      }

    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
    }
  };

  function editSubPack(pack) {
    const obj = pack;
    obj.description = JSON.parse(obj.description);
    setSubscriptions(obj);
    setShowForm(true);
  }

  function deleteSubPack(pack) {
    setSubscriptions(pack);
    setShow(true)
  }

  useEffect(() => {
    fetchAllSubscription().then((res) => {
      if (res.status) {
        setLoading(false);
        setSubscriptionDetails(res?.subscriptions);
      } else {
        toast.error("Failed to load subscriptions. Please try again.");
      }
    }).catch((error) => {
      toast.error("Unable to fetch subscriptions at the moment.");
    });
  }, [showForm]);


  const animatedComponents = makeAnimated();

  return (
    <>
      {loading ?
        <Loading />
        :
        <>
          {
            showForm ? (

              <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 42em" }} >

                {/* Toast container */}
                < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

                <div className="app-ecommerce">
                  <div className="row">
                    <div className="col-12 col-lg-8">
                      <div className="card mb-6">
                        <div className="card-header">
                          <h5 className="card-tile mb-0">Edit Subscription Package </h5>
                        </div>
                        <div className="card-body">

                          <form onSubmit={(event) => { handleEdit(event) }}>
                            <div className="row gx-5 mb-5">
                              <div className="col">
                                <div className="form-floating form-floating-outline">
                                  <input type="text" className="form-control" value={subscriptions.name} onChange={(event) => { setSubscriptions({ ...subscriptions, name: event.target.value }) }} placeholder="Enter Name" />
                                  <label htmlFor="name">Name</label>
                                </div>
                              </div>
                            </div>

                            <div className="row gx-5 mb-5 mt-5">
                              <div className="col">
                                <div className="form-floating form-floating-outline">
                                  <input type="text" className="form-control" value={subscriptions.total_request} onChange={(event) => { setSubscriptions({ ...subscriptions, total_request: event.target.value }) }} placeholder="Enter Total Request" />
                                  <label htmlFor="totalrequest">Total Request</label>
                                </div>
                              </div>
                            </div>

                            <div className="row gx-5 mb-5">
                              <div className="col">
                                <div className="form-floating form-floating-outline">
                                  <input type="text" className="form-control" value={subscriptions.amount} onChange={(event) => { setSubscriptions({ ...subscriptions, amount: event.target.value }) }} placeholder="Enter Amount" />
                                  <label htmlFor="amount">Amount</label>
                                </div>
                              </div>
                            </div>


                            <div className=" gx-5 mb-5">
                              {subscriptions.description.map((desc, index) => {
                                return <div className="col mb-2 d-flex">
                                  <div className="form-floating form-floating-outline w-100 me-3">
                                    <input type="text" value={desc} onChange={(event) => { const data = structuredClone(subscriptions); data.description[index] = event.target.value; setSubscriptions(data) }} className="form-control" placeholder="Enter Description" />
                                    <label htmlFor="description">Description</label>
                                  </div>
                                  {index > 0 ? <FaTrash color='red' onClick={() => { const data = structuredClone(subscriptions); data.description = data.description.filter((elem, findex) => index != findex); setSubscriptions(data) }} size={20} style={{ cursor: "pointer" }} /> : null}
                                </div>
                              })}
                              <button type='button' className='mt-3 btn btn-primary w-25' onClick={() => { const data = structuredClone(subscriptions); data.description = [...data.description, ""]; setSubscriptions(data) }} >
                                <FaPlus />
                              </button>
                            </div>


                            <div className="row gx-5 mb-5">
                              <div className="col">
                                <div className="form-floating form-floating-outline">
                                  <select className="form-select form-select-sm" id="status" value={subscriptions.status} onChange={(event) => setSubscriptions({ ...subscriptions, status: parseInt(event.target.value) })} required>
                                    <option value="">Select Status</option>
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                  </select>
                                  <label htmlFor="status">Status</label>
                                </div>
                              </div>
                            </div>

                            <div className="mb-5 col ecommerce-select2-dropdown d-flex justify-content-between align-items-center mt-4 w-100">
                              <div className="form-floating form-floating-outline w-100 me-4">
                                <select className="form-select form-select-sm" data-placeholder="Select Category" value={subscriptions.type} onChange={(event) => { setSubscriptions({ ...subscriptions, type: event.target.value }) }}>
                                  <option value="">Select Type</option>
                                  <option value="1">Monthly</option>
                                  <option value="2">Yearly</option>
                                </select>
                                <label htmlFor="level">Type</label>
                              </div>
                            </div>

                            <div className="row gx-5 mb-5">
                              <div className="col">
                                <div className="form-floating form-floating-outline">
                                  <select className="form-select form-select-sm" id="status" value={subscriptions.grade} onChange={(event) => setSubscriptions({ ...subscriptions, grade: event.target.value })}>
                                    <option value="">Select Level</option>
                                    <option value="6-8">6-8</option>
                                    <option value="9-10">9-10</option>
                                    <option value="11-12">11-12</option>
                                  </select>
                                  <label htmlFor="level">Level</label>
                                </div>
                              </div>
                            </div>


                            {/* <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        defaultValue={options.filter((elem) => { return subscriptions.grade.includes(elem.value) })}
                        isMulti
                        options={options}
                        onChange={(value) => { if (value) { const data = structuredClone(subscriptions); data.grade = (value.map((elem) => elem.value)); setSubscriptions(data) } }}
                      /> */}

                            <div className="col-md-4 d-flex gap-4 mx-4 mt-4">
                              <button type="submit" className="btn btn-primary">Update</button>
                              <button type="submit" className="btn btn-primary" onClick={() => { setShowForm(false) }}>Cancel</button>
                            </div>

                          </form>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div >

            ) : (

              <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 25em" }}>

                {/* Toast container */}
                < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

                <div className="">
                  <div className="card-header border-bottom d-flex justify-content-between align-items-center pb-3">
                    <div className="card-header ">
                      <h5 className="card-title mb-0"> Subscription Package</h5>
                    </div>
                    <Link to="/admin/addpackage" className="card-header">
                      <button className="btn btn-primary"> Add Package</button>
                    </Link>
                  </div>


                  {subscriptionDetails.length > 0 ?

                    <div className="row mt-4">
                      {subscriptionDetails.map((pack, indx) => {
                        // const levelName = JSON.parse(pack.grade);
                        const description = JSON.parse(pack.description);

                        return <div className="col-md-3" key={indx}>
                          <div className="card" style={{ width: "18rem", margin: "10px" }}>

                            <div className="d-flex flex-row justify-content-between">
                              <div className="mt-3 ms-4">{pack.status ? <div style={{ color: "green" }}>Active</div> : <div style={{ color: "red" }}>Inactive</div>}</div>

                              <div>
                                <button className="btn btn-icon" data-toggle="tooltip" data-placement="top" title="Edit">
                                  <MdModeEdit style={{ color: "#666CFF" }} onClick={() => { editSubPack(pack) }} />
                                </button>

                                <button className="btn btn-icon mx-2" data-toggle="tooltip" data-placement="top" title="Delete">
                                  <MdDelete style={{ color: "red" }} onClick={() => { deleteSubPack(pack) }} />
                                </button>
                              </div>
                            </div>

                            <div className="card-body">
                              <div className="text-center">
                                <h3 className="text-primary">{pack.name}</h3>
                                <h5> &#8377;{pack.amount}/{pack.type === 2 ? "Yearly" : "Monthly"} </h5>
                              </div>

                              {/* <div className="d-flex flex-wrap align-items-center mb-2">
                          <h6 className="m-0">Level :</h6>
                          {levelName.map((level, i) => (
                            <p className="card-title ms-2 mt-0 mb-0" key={i}> {i == levelName.length - 1 ? level : level + ','} </p>
                          ))}
                        </div> */}

                              <div className="card-title d-flex flex-wrap align-items-center"><h6 className="m-0 me-2">Level:</h6> {pack.grade}</div>
                              <div className="card-title d-flex flex-wrap align-items-center"><h6 className="m-0 me-2">Total Request:</h6> {pack.request_type ==2 ? 'Unlimited' : pack.total_request}</div>

                              <h6>Description:</h6>
                              <ul>
                                {description.map((desc, idx) => (
                                  <li className="card-text" key={idx}>{desc}</li>
                                ))}
                              </ul>

                            </div>
                          </div>
                        </div>

                      })}
                    </div>
                    :
                    <NoData />
                  }

                </div>
              </div>
            )
          }
        </>
      }


      {/* modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete this language?
        </Modal.Body>

        <div className="col-md-11 my-4 mx-5">
          <button type="button" className="btn btn-secondary" onClick={handleClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-danger mt-3" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </Modal>
    </>
  )
}
